export default __webpack_public_path__ + "static/media/EM0550.34I-41828_-25086_0.4cbf30ac.jpg";